import clsx, { ClassArray } from "clsx";
import { twMerge } from "tailwind-merge";

export const cn = (...args: ClassArray) => {
    return twMerge(clsx(args));
};
